import axios from 'axios'

export default {
	GetBuzones (email) {
		return new Promise((resolve, reject) => {
			axios.post('webmail/php/api/get-buzones.php', {email: email})
				.then(res => {
					resolve(res.data)
				})
				.catch(e => {
					console.error(e)
					reject(e.response.data.error)
				})
		})
	},
	GetMensajes (email, buzon, pagina) {
		return new Promise((resolve, reject) => {
			axios.post('webmail/php/api/get-mensajes.php', {buzon: buzon, email: email, pagina: pagina})
				.then(res => {
					resolve(res.data)
				})
				.catch(e => {
					console.error(e)
					reject(e.response.data.error)
				})
		})
	},
	GetMensaje (email, buzon, numero) {
		numero = parseInt(numero)
		return new Promise((resolve, reject) => {
			axios.post('webmail/php/api/get-mensaje.php', {email: email, buzon: buzon, numero: numero})
				.then(res => {
					resolve(res.data)
				})
				.catch(e => {
					reject(e.response.data.error)
				})
		})
	},
	SetFlag (email, buzon, numeroMensaje, flag) {
		numeroMensaje = numeroMensaje.map(m => parseInt(m))
		return new Promise((resolve, reject) => {
			axios.post('webmail/php/api/set-flag.php', {email: email, flag: flag, buzon: buzon, numero: numeroMensaje})
				.then(resolve)
				.catch(e => {
					console.error(e)
					reject(e.response.data.error)
				})
		})
	},
	SetLeido (email, buzon, numeroMensaje, leido) {
		numeroMensaje = numeroMensaje.map(m => parseInt(m))
		return new Promise((resolve, reject) => {
			axios.post('webmail/php/api/set-leido.php', {email: email, leido: leido, buzon: buzon, numero: numeroMensaje})
				.then(resolve)
				.catch(e => {
					console.error(e)
					reject(e.response.data.error)
				})
		})
	},
	enviarPapelera (email, buzon, uid) {
		return new Promise((resolve, reject) => {
			axios.post('webmail/php/api/enviar-papelera.php', {email, buzon, uid})
				.then(res => {
					resolve()
				})
				.catch(e => {
					reject(e.response.data.error)
				})
		})
	},
	enviarBuzon (email, buzon, uid, Destino) {
		return new Promise((resolve, reject) => {
			axios.post('webmail/php/api/enviar-buzon.php', {email, buzon, uid, Destino})
				.then(res => {
					resolve()
				})
				.catch(e => {
					reject(e.response.data.error)
				})
		})
	},
	Buscar (email, buzon, cadena) {
		return new Promise((resolve, reject) => {
			axios.post('webmail/php/api/buscador.php', {email: email, buzon: buzon, cadena: cadena})
				.then(res => {
					resolve(res.data)
				})
				.catch(e => {
					reject(e.response.data.error)
				})
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/webmail/vue/servicios.js